import type { User } from 'graphql-models';
import type { Factory } from './helpers';

const MOCK_USER: User = {
  email: 'john.doe@example.com',
  firstName: 'John',
  id: '1',
  lastName: 'Doe',
  notificationPreferences: '{"orderReceived":["email"],"orderPacked":["sms"]}',
  phone: '123-456-7890',
  privacyPolicyAccepted: true,
  privacyPolicyAcceptedAt: new Date('Mon Mar 21 2025 15:15:35 GMT+0100').toISOString(),
};

export const userFactory: Factory<User> = (overrides) => ({
  ...MOCK_USER,
  ...overrides,
});
